import { useParams, useLocation } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import api from "../../api";

import { Modal } from "react-bootstrap";

import "bootstrap/js/dist/modal.js";

import ModalComponentN3 from "../../components/Modal/ModalComponentN3";
import Loading from "../../components/Loading";

export default function SearchN3Table() {
    const params = useParams();
    const location = useLocation();
    const [N3Data, setN3Data] = useState([]);
    const [loading, setLoading] = useState(true);

    const [show, setShow] = useState(false);
    const [dataModal, setDataModal] = useState("");

    const fetchN3Records = useCallback(() => {
        let searchAdvanced = false;
        const formData = new FormData();

        if (location?.search) {
            searchAdvanced = true;
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.forEach((v, k) => {
                formData.append(`filter[${k}]`, v);
            });
        }

        const urlParamsData = new URLSearchParams(formData);
        const sendParam = searchAdvanced ? urlParamsData : `filter[search]=${params?.name}`;

        api.get(`/search/n3?${sendParam}`)
            .then((response) => {
                const data = response.data;
                setN3Data(data.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [params?.name, location]);

    useEffect(() => {
        if (params?.name) {
            fetchN3Records();
        }
    }, [params, fetchN3Records]);

    if (loading) return <Loading />;

    return (
        <div className="container">
            {/* <div className="my-5"></div> */}
            <div className="h5 mb-4">Search : {params?.name}</div>

            <div className="table-responsive">
                <table className="table caption-top table-striped table-bordered">
                    <caption>In-silico SNP Primer</caption>
                    <thead>
                        <tr>
                            <th scope="col" className="font-monospace">
                                Alleles
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Primer ID
                            </th>
                            <th scope="col" className="text-center">
                                {/* การดำเนินการ */}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {N3Data.length > 0 ? (
                            N3Data.map((item) => {
                                return (
                                    <tr key={item?.id}>
                                        <th scope="row" className="font-monospace">
                                            {item?.alleles}
                                        </th>
                                        <td className="font-monospace text-end">{item?.primer_id}</td>
                                        <td className="text-center">
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={() => {
                                                    setShow(true);
                                                    setDataModal(item);
                                                }}
                                            >
                                                อ่านเพิ่มเติม
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td className="text-center" colSpan={3}>
                                    ไม่พบข้อมูลที่Search
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title className="font-monospace">Alleles : {dataModal?.alleles}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalComponentN3 data={dataModal} />
                </Modal.Body>
            </Modal>

            <br />
            <br />
            <br />
        </div>
    );
}
